import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import supabase from '../../supabaseClient'
import Loader from '../Loader'
import SignupLayout from './SignupLayout'
import {
  communityLoginRedirectState,
  fetchExistingCommunityMembership,
  shouldAllowCommunitySignupFlow,
} from '../../utils/existingCommunityCheck'

/**
 * Blocks community signup / setup routes when the signed-in user already
 * belongs to a different community. Redirects to /community/login with
 * a popup payload (alreadyInCommunity).
 */
export default function CommunitySignupGuard({ children }) {
  const navigate = useNavigate()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let cancelled = false

    async function run() {
      const {
        data: { session },
      } = await supabase.auth.getSession()

      if (!session?.user) {
        if (!cancelled) setReady(true)
        return
      }

      const membership = await fetchExistingCommunityMembership(session.user.id)
      if (!membership || shouldAllowCommunitySignupFlow(membership.communityId)) {
        if (!cancelled) setReady(true)
        return
      }

      if (!cancelled) {
        navigate('/community/login', {
          replace: true,
          state: communityLoginRedirectState(membership.communityName),
        })
      }
    }

    run()
    return () => {
      cancelled = true
    }
  }, [navigate])

  if (!ready) {
    return (
      <SignupLayout showLogin={false}>
        <div className="flex flex-col items-center justify-center pt-12">
          <Loader size={28} className="text-[var(--signup-bg-base)]" />
        </div>
      </SignupLayout>
    )
  }

  return children
}
